import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
`

export const Content = styled(Box)`
  width: fit-content;
  padding: 8px 12px;
  border-radius: 30px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
`
